<div>
  <form [formGroup]="stepFormGroup" class="step-container">
    <mat-card class="card-general">
      <mat-card-title>Formas de solucionar la maloclusi&oacute;n</mat-card-title>
      <mat-card-content class="row w-100 w-md-75 d-flex flex-column justify-content-start align-items-center align-items-md-start">
        <div *ngFor="let item of aditionalMechanicsTypeOptions" class="row justify-content-start w-100">
          <mat-checkbox style="width: fit-content;" [checked]="item.checked" (change)="onCheckboxChange($event.checked, item.value)" (click)="resetFormControlsStep6(stepFormGroup, item.controlName)" class="col text-start"><span style="white-space:normal;">{{item.display}}</span></mat-checkbox>
          <div *ngIf="item.value == 0 && item.checked" class="col">
            <mat-radio-group aria-label="Seleciona una opción" [formControlName]="item.controlName" class="d-flex flex-wrap gap-2 gap-md-4">
              <div class="row" *ngFor="let option of classTypeCustomOptions">
                <mat-radio-button [value]="option.value"
                [checked]="option.value == getControl(stepFormGroup, item.controlName)"><span style="white-space:normal;">{{option.display}}</span></mat-radio-button>
              </div>
            </mat-radio-group>
          </div>

          <!-- Type 2 elastic options -->
          <div *ngIf="item.value == 8 && item.checked" class="col">
            <div *ngFor="let options of class2TypeCustomOptions">
              <b><label>{{options.name}}</label></b>

              <mat-radio-group aria-label="Seleciona una opción" [formControlName]="item.controlName+options.key" class="d-flex flex-wrap gap-2 gap-md-4">
                <div class="row" *ngFor="let option of options.values">
                  <mat-radio-button [value]="option.value"
                  [checked]="option.value == getControl(stepFormGroup, item.controlName+options.key) || options.key == 'Inferior'"><span style="white-space:normal;">{{option.display}}</span></mat-radio-button>
                </div>
              </mat-radio-group>
            </div>

          </div>
          <!-- Type 3 elastic options -->
          <div *ngIf="item.value == 9 && item.checked" class="col">
            <div *ngFor="let options of class3TypeCustomOptions">
              <b><label>{{options.name}}</label></b>
              <mat-radio-group aria-label="Seleciona una opción" [formControlName]="item.controlName+options.key" class="d-flex flex-wrap gap-2 gap-md-4">
                <div class="row" *ngFor="let option of options.values">
                  <mat-radio-button [value]="option.value"
                    [checked]="option.value == getControl(stepFormGroup, item.controlName+options.key) || options.key == 'Superior'"><span
                      style="white-space:normal;">{{option.display}}</span></mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
          </div>

          <!-- Manufacturing Type -->
          <div *ngIf="onCheckManufacturingType(item.display) && item.checked" class="col">
            <mat-radio-group aria-label="Seleciona una opción" [formControlName]="item.controlName" class="d-flex flex-wrap gap-2 gap-md-4">
              <div class="row" *ngFor="let option of manufacturingTypeOptions">
                <mat-radio-button [value]="option.value"
                [checked]="option.value == getControl(stepFormGroup, item.controlName) || (getControl(stepFormGroup, item.controlName)==null && option.value==0)"><span style="white-space:normal;">{{option.display}}</span></mat-radio-button>
              </div>
            </mat-radio-group>
          </div>

          <!-- Crossed Elastic Type -->
          <div *ngIf="onCheckCrossedElasticsType(item.value) && item.checked" class="col">
            <div *ngFor="let options of CrossedElasticsTypeNewOptions">
              <b><label>{{options.name}}</label></b>
              <mat-radio-group aria-label="Seleciona una opción" [formControlName]="item.controlName+options.key" class="d-flex flex-wrap gap-2 gap-md-4">
                <div class="row" *ngFor="let option of options.values">
                  <mat-radio-button [value]="option.value"
                  [checked]="true"><span style="white-space:normal;">{{option.display}}</span></mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
           
          </div>
        </div>
        <!-- <div class="col-12 col-lg-10 text-center" *ngIf="isSkeletalAnchorChecked()">
          <textarea maxlength="620" matInput placeholder="Favor de dar instrucciones" name="aditionalMechanicsValuesComments" formControlName="aditionalMechanicsValuesComments" style="height: 120px;"></textarea>
        </div> -->
        
      </mat-card-content>
    </mat-card>

    <mat-card class="card-general">
      <mat-card-title>Mecánicas adicionales dispuesto a utlizar</mat-card-title>
      <mat-card-content class="mt-2 d-flex flex-column">
        
        <div class="row w-100  justify-content-start">
          <b><p>No necesariamente se utilizarán todas, pero queremos saber cuáles estás dispuesto a utilizar en caso de ser recomendadas por Aliwell.</p></b>
          <h5>Deselecciona las que NO estás dispuesto a utilizar:</h5>
          <div *ngFor="let item2 of aditionalMechanicsToUseOptions" class="row justify-content-start w-100">
            <mat-checkbox style="width: fit-content;" [checked]="item2.checked"  class="col text-start" (change)="onCheckboxMechanicsToUseChange($event.checked,item2.value)"><span style="white-space:normal;" >{{item2.display}}</span></mat-checkbox>
          </div>
          <div class="col-12 col-lg-10 text-center" *ngIf="isSkeletalAnchorChecked()">
              <textarea maxlength="620" matInput placeholder="Favor de dar instrucciones" name="aditionalMechanicsValuesComments"
                formControlName="aditionalMechanicsValuesComments" style="height: 120px;"></textarea>
          </div>
        </div>
        
      </mat-card-content>
    </mat-card>

    <h3><strong>Movimientos Verticales</strong></h3>
    <mat-card class="card-general">
      <mat-card-title>Sobremordida Vertical</mat-card-title>
      <mat-card-content class="mt-2 d-flex flex-column gap-5">
        <div class="row w-100  justify-content-start">
          <mat-radio-group aria-label="Seleciona una opción" formControlName="verticalOverbiteType" class="col-12 col-lg-10 d-flex flex-wrap flex-column gap-4">
            <div class="d-flex align-items-center gap-4" *ngFor="let item of verticalOverbiteTypeOptions">
              <mat-radio-button [value]="item.value" (click)="resetFormControl(stepFormGroup, 'verticalOverbiteQuantity')"
                                [checked]="item.value == getControl(stepFormGroup,'verticalOverbiteType')" class="">
                <span style="white-space:normal;">{{item.display}}</span>
              </mat-radio-button>
              <mat-form-field style="width: fit-content; height: fit-content;" *ngIf="item.value == 2 && item.value == getControl(stepFormGroup,'verticalOverbiteType')">
                <input matInput type="number" min="0.1" formControlName="verticalOverbiteQuantity" step="0.1">
              </mat-form-field>
              <span *ngIf="item.value == 2 && item.value == getControl(stepFormGroup,'verticalOverbiteType')">mm</span>
            </div>
          </mat-radio-group>
          <div class="col-12 col-lg-2 text-center">
            <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Dientes-16.svg" />
          </div>
        </div>
      </mat-card-content>
    </mat-card>


    <div class="d-flex justify-content-center gap-4" *ngIf="isCaseDetail">
      <button mat-button matStepperPrevious class="button secondary-button"><mat-icon>chevron_left</mat-icon> Anterior</button>
      <button mat-button matStepperNext data-testid="nextStep6" class="button secondary-button" (click)="updateStepPrescription()" [disabled]="disabledButtonStages()">Guardar y Continuar <mat-icon>chevron_right</mat-icon></button>
    </div>
  </form>
</div>
